import { BaseField } from './BaseField';

const imgGardenAreaIcon = "/assets/garden-area-icon.svg";

export class GardenPlotBalconyField extends BaseField {
  constructor() {
    super({
      key: 'garden_plot_balcony',
      icon: imgGardenAreaIcon,
      defaultLabel: null
    });
  }

  renderForList(property) {
    const plot = property.specifications.features.plot;
    const garden = property.specifications.features.garden;
    const balcony = property.specifications.features.balcony;

    if (plot?.available && plot.area > 0) {
      return { label: 'Działka', value: `${plot.area} m²` };
    }
    if (garden?.available && garden.area > 0) {
      return { label: 'Ogród', value: `${garden.area} m²` };
    }
    if (garden?.available && garden.area === 0) {
      return { label: 'Ogród', value: 'tak' };
    }
    if (balcony) {
      return { label: 'Balkon', value: 'tak' };
    }
    return { label: 'Ogród', value: 'brak' };
  }

  renderForCard(property) {
    return this.renderForList(property);
  }
}
